import { BaseService, endpoints, http } from './base';
import { INote, INoteFilter, INoteForm, INotes } from '@/types';
import { INotePostFilter, INotePostForm, INotePosts } from '@/types/notePost';

export class NoteService extends BaseService<INote> {
  constructor() {
    super(endpoints.notes.default);
  }

  public async getDetail(id: string): Promise<INote> {
    const { data: res } = await http.get(this.url + '/' + id);
    return res;
  }

  public async getAll(params?: INoteFilter): Promise<INotes> {
    const { data: res } = await http.get(this.url, { params });
    return res;
  }

  public async storeData(body: INoteForm): Promise<INote> {
    const { data } = await http.post(this.url, body);
    return data;
  }

  public async updateData(id: string, body: INoteForm): Promise<INote> {
    const { data: res } = await http.patch(this.url + '/' + id, body);
    return res;
  }

  public async getNotePosts(id: string, params?: INotePostFilter): Promise<INotePosts> {
    const { data: res } = await http.get(this.url + '/' + id + '/note-posts', { params });
    return res;
  }

  public async updateNotePost(id: string, body: INotePostForm) {
    const { data: res } = await http.patch('/note-posts/' + id, body);
    return res;
  }

  public async getNoteArticles(params?: INotePostFilter): Promise<INotePosts> {
    const { data: res } = await http.get('/note-posts', { params });
    return res;
  }
}
